import Select from './Select'
import CreatableSelect from './CreatableSelect'

export default Select
export { CreatableSelect, Select }
